<template>
    <v-row>
        <v-col cols="12" md="7" lg="8" v-if="!isMobile" class="img-col"/>
        <v-col cols="12" md="5" lg="4">
            <confirm-mail class="mt-7"/>
        </v-col>
    </v-row>
</template>

<script>

import {mapMutations, mapState} from 'vuex'

import ConfirmMail from '@/components/entrance/ConfirmMail'

import firebase from 'firebase/app'
import 'firebase/auth'

export default {
    components: {
        ConfirmMail
    },
    data() {
        return {
            interval: null
        }
    },
    async created() {
        const vm = this
        await vm.updateUser()
    },
    computed: {
        ...mapState(['loadingUser'])
    },
    methods: {
        ...mapMutations(['setCurrentUser']),
        async updateUser() {
            const vm = this
            let user = await firebase.auth().currentUser;
            vm.interval = setInterval(() => {
                user.reload().then(() => {
                    const refreshUser = firebase.auth().currentUser;
                    vm.setCurrentUser(refreshUser)
                    vm.redirect(refreshUser)
                })
            }, 2000);
        },
        destroyInterval() {
            const vm = this
            clearInterval(vm.interval)
        },
        redirect(user) {
            const vm = this
            if (user && user.emailVerified) {
                vm.destroyInterval()
                return vm.accountType ? vm.$router.push({name: 'basic-info'}) : vm.$router.push({name: 'select-profile'})
            }
        }
    },
}
</script>

<style scoped>

.img-col {
    position: sticky;
    top: 48px;
    background-size: cover;
    background-position: center;
    height: calc(100vh - 20px);
    background-image: url('../../assets/img/confirm_mail.png');
}

</style>
